// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"59e5837a","241":"21b4c128","383":"b7c5f137","545":"f4570e1a","704":"386089de","722":"7f44f4d0"}[chunkId] + ".chunk.js";
};